import React from 'react';
import PropTypes from 'prop-types';
import { Input, InfoCard } from 'app/components';
import { Question, Sparkle } from '@phosphor-icons/react';
import DateTime from './dateTime';
import MeetingDetails from './meetingDetails';
import VenueDropdown from './venueDropdown';

const EventOccasion = (props) => {
  const {
    updateSubStep,
    setFormData, 
    formData, 
    error, 
    setError,
  } = props;

  return (
    <>
      <h1 className="heading-36 mb-9">When and where?</h1>
      <div className="flex flex-col gap-8 overflow-auto pr-4">
       
        <DateTime
          formData={formData} 
          setFormData={setFormData} 
        />

        {formData.type === 'online' && (
          <>
            <MeetingDetails formData={formData} 
              setFormData={setFormData} 
              error={error} 
              setError={setError}/>
            <InfoCard
              content="Details will be available to attendees 30 mins before the event starts on their My Bookings page, and an email will be sent 30 mins prior."
              icon={<Sparkle weight="fill"
                size={24} />}
            />
          </>
        )}

        {formData.type === 'offline' && (
          <VenueDropdown 
            updateSubStep={updateSubStep}
            formData={formData} 
            setFormData={setFormData} 
            error={error} 
            setError={setError} 
          />
        )}
      </div>
    </>
  );
};

EventOccasion.propTypes = {
  setCurrentScreen: PropTypes.func,
  setProgress: PropTypes.func,
  setFormData: PropTypes.func,
  formData: PropTypes.object,
  error: PropTypes.object,
  setError: PropTypes.func,
};

EventOccasion.defalutProps = {
  setCurrentScreen: () => {},
  setProgress:() => {},
  setFormData: () => {},
  formData: {},
  error: {},
  setError: () => {},
}

export default EventOccasion;
